/* eslint-disable unicorn/filename-case */
// TODO: fix linter
// Add <%= javascript_pack_tag "user-site" %> in erb view to use this bundle
// and components provided in context

// eslint-disable-next-line import/no-internal-modules
import "../user_site/lib/react-query";

const componentRequireContext = require.context(
  "user_site/rails-components",
  true
);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const ReactRailsUjs = require("react_ujs");

// Expose ReactRailsUJS as a global so inline `.js.erb` AJAX responses can call
// ReactRailsUJS.mountComponents / unmountComponents (used by the gooten medium
// switch, product-gallery favorite buttons, etc.). The old Webpacker/Sprockets
// build left this on `window`; Shakapacker bundles it module-scoped, so without
// this re-export the eval'd response throws "ReferenceError: ReactRailsUJS is
// not defined" and halts mid-script — e.g. the gooten medium selection never
// finalizes and Add to Cart keeps submitting the previously selected medium.
(window as unknown as { ReactRailsUJS: unknown }).ReactRailsUJS = ReactRailsUjs;

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUjs.useContext(componentRequireContext);
